import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BotonFormUnico = ({
  onClick,
  bgColor,
  text = 'siguiente paso',
  type = 'button',
  step,
  disabled = false
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={cn(
        bgColor,
        'inline-flex items-center w-full relative py-10 pl-26 pr-14 rounded-full cursor-pointer duration-40',
        {
          '-translate-x-[18rem]': step === 0,
          'opacity-50 grayscale !cursor-not-allowed': disabled
        }
      )}
    >
      <p className="w-full p1 relative z-3 uppercase text-center text-white">{text}</p>
      <svg
        className="relative z-3 ml-12"
        width="8"
        height="13"
        viewBox="0 0 8 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 12L7 6.5L1 1" stroke="#FEFEFE" strokeWidth="0.420635" />
      </svg>
    </button>
  );
};
export default BotonFormUnico;
